import { SliderMark } from 'types/shared/slider-mark.type';

const allFields = [
  'gilScoreTotal',
  'gilScoreActive',
  'wounds',
  'length',
  'weight',
  'adultFemaleLice',
  'skinBleeding',
  'stationaryLice',
  'mobileLice',
  'scottishLice',
  'backboneDeformity',
  'thinness',
  'maturation',
  'scaleLoss',
  'snoutWounds',
  'jawDeformity',
  'paleEye',
  'eyeDamage',
  'gillCover',
  'gillStatus',
  'finStatus',
  'firstImpression',
];

const CountMarks: SliderMark[] = [
  { value: -1, label: 'N/A' },
  { value: 0, label: '0' },
  { value: 1, label: '1' },
  { value: 2, label: '2' },
  { value: 3, label: '3' },
  { value: 4, label: '4' },
  { value: 5, label: '5' },
  { value: 6, label: '6' },
  { value: 7, label: '7' },
  { value: 8, label: '8' },
  { value: 9, label: '9' },
  { value: 10, label: '10' },
];

const buttons = [
  { label: 'N/A', value: -1 },
  { label: '0', value: 0 },
  { label: '1', value: 1 },
  { label: '2', value: 2 },
  { label: '3', value: 3 },
];

const templateFields = [
  // Lice group (slider)
  { order: 1, name: 'stationaryLice', type: 'slider' },
  { order: 2, name: 'mobileLice', type: 'slider' },
  { order: 3, name: 'adultFemaleLice', type: 'slider' },
  { order: 4, name: 'scottishLice', type: 'slider' },
  // Welfare indicators (button/select)
  { order: 5, name: 'firstImpression', type: 'select' },
  { order: 6, name: 'backboneDeformity', type: 'select' },
  { order: 7, name: 'thinness', type: 'select' },
  { order: 8, name: 'maturation', type: 'select' },
  { order: 9, name: 'scaleLoss', type: 'select' },
  { order: 10, name: 'skinBleeding', type: 'select' },
  { order: 11, name: 'wounds', type: 'select' },
  { order: 12, name: 'snoutWounds', type: 'select' },
  { order: 13, name: 'jawDeformity', type: 'select' },
  { order: 14, name: 'paleEye', type: 'select' },
  { order: 15, name: 'eyeDamage', type: 'select' },
  { order: 16, name: 'gillCover', type: 'select' },
  { order: 17, name: 'gillStatus', type: 'select' },
  { order: 18, name: 'finStatus', type: 'select' },
  { order: 19, name: 'gilScoreActive', type: 'select' },
  { order: 20, name: 'gilScoreTotal', type: 'select' },
  { order: 21, name: 'noseDamage', type: 'select' },
];

export { templateFields, buttons, CountMarks, allFields };